<template>
  <div class="bg-black height-100 watch-info">
    <div class="main-polv" v-if="videoData">
      <div class="flex polv-tit">
        <div :span="12" class="flex align-center">
          <span class="schedule-name">{{ videoData.scheduleName }}</span>
        </div>
        <div :span="6" class="flex align-center">
          <div @click="goAsk()" class="flex align-center cursor" style="margin-right: 20px">
            <img src="./img/ask-icon.png" class="icon-play" />提问
          </div>
          <div @click="goEvaluate()" class="flex align-center cursor" v-if="isShowEva">
            <img src="./img/evaluate-icon.png" class="icon-play" />评价
          </div>
          <div @click="gpResource()" class="flex align-center cursor">
            <img src="./img/resource-icon.png" class="icon-play" />资源
          </div>
          <div class="header_title">
            <h1 class="icon_container">
              <div class="icon" v-if="userInfo.nickName">
                <img :src="userInfo.headImgUrl" alt="" class="stu-logo" />
              </div>
              <span>{{ userInfo.nickName }}</span>
            </h1>
          </div>
        </div>
      </div>
      <a-row class="panel-body" type="flex" justify="space-between">
        <a-col :span="18" class="left-panel height-100">
          <!-- <div id="live" class="live height-100">
            <div id="player" class="height-100 width-100"></div>
          </div> -->
          <div id="main">
            <div class="bjc-player-wrapper" id="bjy-player-container" style="height: calc(100vh - 60px);">
              <!-- <video class="video video-js vjs-default-skin">
              </video> -->
            </div>
          </div>
        </a-col>
        <a-col :span="6" class="hide-pagination height-100 flex-column">
          <div class="relative bg-dark-black plv-watch-pc height-100">
            <div class="box">
              <div id="chat" class="width-100">
                <chat></chat>
              </div>
              <!-- <resource :pushType="videoData.pushType" :classesName="videoData.classesName"
                v-if="videoData.activityStatus !== 0" :activityInfo="videoData" :planclassesId="studentData.planclassesId"
                @getResorce="getResorce" :resourceList="resourceList"></resource> -->
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <ask-modal :visible.sync="askVisible" @refresh="refresh"></ask-modal>
    <evaluate-modal :visible.sync="evaluateVisible" @refresh="evaluatRefresh"
      :scheduleId="studentData.scheduleId"></evaluate-modal>
    <resource :pushType="videoData.pushType" :classesName="videoData.classesName" v-if="videoData.activityStatus !== 0"
      :visible.sync="resourceVisible" :activityInfo="videoData" :planclassesId="studentData.planclassesId"
      @getResorce="getResorce" :resourceList="resourceList" @analysisPPt="analysisPPt" @closeResource="closeResource"
      :width="'25%'">
    </resource>
  </div>
</template>
<script>
import Vue from 'vue'
// import resource from '../watchLiveV2/module/resource'
import resource from '@/components/wacthModule/resource'
import askModal from '@/components/wacthModule/askModal'
import evaluateModal from '@/components/evaluateModal/evaluateModal'
import chat from './module/chat'
import {
  PLAYBACK_SPEED_PRESETS,
  setupBPlayerCustomSpeed,
} from '@/utils/playbackSpeed'
export default {
  components: { resource, askModal, evaluateModal, chat },
  data() {
    return {
      studentData: {},
      videoData: {},
      lastWatchTime: 0,
      polyvWatchTimer: null,
      polvLastWatchTime: 0,
      polvStartWatchTime: 0,
      userInfo: Vue.ls.get('USER_INFO'),
      resourceList: [],
      evaluateVisible: false,
      askVisible: false,
      isShowEva: false,
      resourceVisible: false,
      bplayer: null
    }
  },
  created() {
    if (this.$route.query) {
      this.studentData = this.$route.query
    }
    if (this.polyvWatchTimer) {
      clearInterval(this.polyvWatchTimer)
    }
    this.polyvWatchTimer = setInterval(() => {
      this.savePolyWatchTime()
    }, 60000)
    this.initData()
  },
  async mounted() {
    this.getStuVieoData()
    this.getResorce() // 初始化资源列表
     window.onbeforeunload = function () {
      that.savePolyWatchTime(1)
    }
  },
  computed: {},
  destroyed() {
    this.bplayer.destroy()
    this.savePolyWatchTime(1)
  },
  methods: {
    initData() {
      this.userInfo = Vue.ls.get('USER_INFO')
      if (this.$route.query) {
        this.studentData = this.$route.query
      }
      // console.log('scanBeginTime', parseInt(new Date().getTime()))
      this.scanBeginTime = parseInt(new Date().getTime())
    },
    // 获取视频/直播详情数据
    async getStuVieoData() {
      // const res = await this.$http.post(
      //   `/b/classes/wxapp/schedule/v2/check/${this.studentData.classesId}/${this.studentData.scheduleId}`,
      //   { headers: { token: this.studentData.token } }
      // )
      const res = await this.$http.get(
        `/b/classes/web/bjy/live/schedule/info/${this.studentData.classesId}/${this.studentData.scheduleId}`
      )
      console.log(`获取视频/直播详情数据____________________`, res)
      this.videoData = res
      this.lastWatchTime = res.lastWatchTime
      this.loadPlayer()
    },
    loadPlayer() {
      this.bplayer = new BPlayer({
        container: document.getElementById('bjy-player-container'),
        // memory: true,
        enableDrag: true,
        // maxWatchTime: 36,
        audioMode: true,
        // 主题色，正确的颜色变量
        theme: '',
        rateList: PLAYBACK_SPEED_PRESETS,
        // logo {url, link}
        logo: {
          // url: 'https://test-img.baijiayun.com/0baijiatools/cfb6b3d5217a97fd99855404b9795ed8/图标_logo备份32x.png',
        },
        preload: 'meta',
        volume: 0.75,
        quality: 'superHD',
        autoplay: true,
        disableEncrypt: false,
        plugins: {
          // 字幕
          // subtitle: {
          //   // source of subtitle
          //   url: '',
          //   // color
          //   color: '#fff',
          //   // font-size
          //   fontSize: 18, // or '18px'
          //   // bottom: distance to bottom
          //   bottom: 64, // or 36
          // },
          // // 跑马灯
          // marquee: {
          //   displayMode: 'roll',
          //   rollDuration: 10,
          //   blinkDuration: 10,
          //   type: 1,
          //   count: 2,
          //   color: '#ffffff',
          //   fontOpacity: 1,
          //   fontSize: 20, // or '20px'
          //   fontBold: 0,
          //   backgroundColor: '#1795ff',
          //   backgroundOpacity: 1,
          //   position: 'random',
          //   value: '114141051用户正在观看',
          // },
          // // 水印
          // waterMark: {
          //  // url: 'https://live-cdn.baijiayun.com/homepage/asset/frontend/common/img/logo-blue_3dd169c315.png',
          //   width: 120, // or '120px'
          //   height: 40, // or '40px'
          //   opacity: 0.8,
          //   // top-left || top-right || bottom-left || bottom-right
          //   position: 'top-left',
          // },
        },
        // video: {
        //   url: 'https://test-dlj4jd-video.baijiayun.com/00-upload/video-test/690302_02eb6f27c2d23f8b81dd11016421e6fc_kHfMTTgQ.mp4?t=62ed2446&sign=f43890531793e752432d06fd14cbb6ed&uuid=eed2d47b-5c34-ef1f-02a6-f803111067d2',
        // },
        vid: this.videoData.videoId,
        token: this.videoData.token,
        env: '',
        user: {
          name: this.videoData.name,
          number: this.videoData.number,
        },
        // bplayer-title
      })
      const eventTypes = {
        READY: 'ready', // 播放器初始化完成
        PLAY: 'play', // 首次播放
        PLAYING: 'playing', // 暂停后播放
        PAUSE: 'pause', // 暂停
        SEEKING: 'seeking', // 快进快退中
        WAITING: 'waiting', // 加载中
        SEEKED: 'seeked', // 快进快退结束
        ENDED: 'ended', // 播放结束
        VOLUME_CHANGE: 'volume_change', // 音量变化
        RATE_CHANGE: 'rate_change', // 倍速变化
        ERROR: 'error', // 播放出错
        TIMEUPDATE: 'timeupdate', // 播放进度更新
        LOADEDMETADATA: 'loadedmetadata', //
        QUALITY_CHANGE: 'quality_change', // 切换清晰度
        ENDED_AD: 'ended_ad', // 广告结束
        FULLSCREEN_CHANGE: 'full_screen_change', // 全屏/退出全屏
       // ERROR: 'error' // 错误事件监听
      }
      const that = this
      this.bplayer.on(eventTypes.READY, () => {
        setupBPlayerCustomSpeed(
          that.bplayer,
          document.getElementById('bjy-player-container')
        )
        that.bplayer.seek(that.videoData.lastWatchTime)
      })
      this.bplayer.on(eventTypes.SEEKED, () => {
        console.log('当前观看到')
        that.savePolyWatchTime()
      })
      this.$nextTick(() => {
        $('.bplayer-title').css({ 'display': 'none' })
      })
    },
    // loadPlayer() {
    //   const that = this
    //   var player = new BjcPlayer($('#main').find('.video')[0], {
    //     token: this.videoData.token,
    //     vid: this.videoData.videoId,
    //     playbackRates: [0.7, 1, 1.2, 1.5, 2], // 倍速 传入 [] 隐藏倍速列表
    //     privateDomainPrefix: '', // 专属域名前缀 0.0.2版本开始支持
    //     user_name: this.videoData.name, // 用户名， 主要用于数据统计
    //     user_number: this.videoData.number, // 用户id， 主要用于数据统计
    //     showDurationDisplay: true, // 显示视频时长
    //     showCurrentTimeDisplay: true, // 显示当前观看时间点
    //     autoplay: true,
    //     onerror: function () {
    //       console.log('onplayerror event')
    //     },
    //     onended: function () {
    //       console.log('onplayend event')
    //     },
    //     onplay: function () {
    //       console.log('onplaybegin event')
    //     },
    //     onpause: function () {
    //       console.log('onplaypause event')
    //     },
    //     ontimeupdate: function (data) {
    //       console.log('ontimeupdate event')
    //       console.log('currentTime:' + data.currentTime)
    //       that.lastWatchTime = data.currentTime
    //     },
    //     onseeked: function (data) {
    //       console.log('onseek event')
    //       console.log('seekTime:' + data.currentTime)
    //     },
    //   })
    // },
    // 获取资源列表
    async getResorce() {
      // console.log('进入了')
      this.resourceList = await this.$http.get('/b/classes/web/stu/schedule/resource/v2/' + this.studentData.scheduleId, {
        headers: { token: this.studentData.token }
      })
      console.log('this.resourceList', this.resourceList)
    },
    async savePolyWatchTime() {
      const scanEndTime = parseInt(new Date().getTime())
      // 获取观看进度（单位秒）
      this.lastWatchTime = this.bplayer.currentTime
      const time = this.lastWatchTime - this.polvStartWatchTime
      const params = {
        activityId: this.videoData.activityId,
        classesId: this.studentData.classesId,
        scheduleId: this.studentData.scheduleId,
        planclassesId: this.studentData.planclassesId ? this.studentData.planclassesId : '',
        state: this.videoData.activityStatus,
        startTimeStamp: this.scanBeginTime,
        endTimeStamp: scanEndTime,
        startTime: parseInt(this.polvStartWatchTime * 1000),
        endTime: parseInt(this.lastWatchTime * 1000),
        videoPlayedTime: parseInt(time * 1000),
        // watchDuration: parseInt(time * 1000) > 60000 ? 60000 : parseInt(time * 1000)
        watchDuration: parseInt(scanEndTime - this.scanBeginTime)
      }
      if (time === 0 || time < 0) {
        return
      }
      this.polvStartWatchTime = this.lastWatchTime
      await this.$http.post(`/b/classes/live/v2/saveVideoProgressForPc`, params)
      this.scanBeginTime = scanEndTime
    },
    goAsk() {
      this.askVisible = true
    },
    refresh() {
      // console.log(this.$refs.postRef)
      this.askVisible = false
    },
    goEvaluate() {
      this.evaluateVisible = true
    },
    evaluatRefresh() {
      // console.log(this.$refs.postRef)
      this.evaluateVisible = false
      this.isShowEva = false
    },
    gpResource() {
      this.resourceVisible = true
    },
    closeResource() {
      this.resourceVisible = false
    },
  }
}
</script>
<style scoped lang="less">
@import './index.less';
</style>
